import { trackMixpanelEvent } from '../utils/general';

export const TRANSLATION_KEY = 'STATIC.PAGES.ANALYSIS_CHAT.SLACK';

const SLACK_AGENT_BASE = 'interactive-service/slack-agent';

export const SLACK_AGENT_PATHS = {
    LINK_CONFIRM: `${SLACK_AGENT_BASE}/link/confirm`,
};

export const LINK_TOKEN_PARAM = 'slack_link_token';

export const GENERIC_ERROR_KEY = 'FAILED';

export const INVITE_ERROR_KEYS = {
    404: 'INVITE_EXPIRED',
    409: 'ALREADY_LINKED',
};

export const toastKey = key => `${TRANSLATION_KEY}.TOASTS.${key}`;

export const TOAST_AUTO_CLOSE_MS = 6000;

export const SLACK_AGENT_EVENT_PREFIX = 'Slack Agent';

export const SLACK_AGENT_EVENTS = {
    ACCOUNT_LINKED: 'Account Linked',
    INVITE_OPENED: 'Invite Opened',
};

export const ENTRY_SURFACES = {
    HEADER: 'header',
    ANSWER_ACTION: 'answer_action',
};

export const trackSlackAgentEvent = (eventName, params) =>
    trackMixpanelEvent(SLACK_AGENT_EVENT_PREFIX, eventName, params);
